import React, { Ref, useImperativeHandle, useRef, useState } from 'react';
import FormTextField, { FormTextFieldProps } from './FormTextField';
import styled from '@emotion/styled';
import WatchIcon from '@atlaskit/icon/glyph/watch';
import WatchFilledIcon from '@atlaskit/icon/glyph/watch-filled';

import { IconButton } from '@atlaskit/button/new';
import { useIntl } from 'react-intl';

export const StyledIconContainer = styled.div`
  padding: 3px;
  margin-left: -1px;
`;

const StyledDiv = styled.div<{ smallPlaceholder?: boolean }>`
  input {
    ${props => props.smallPlaceholder && 'font-size: 14px !important;'}
  }
`;

export interface PasswordFieldProps extends FormTextFieldProps {
  smallPlaceholder?: boolean;
}

const PasswordField = (props: PasswordFieldProps, ref: Ref<HTMLInputElement | null>) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [type, setType] = useState<'password' | 'text'>('password');

  useImperativeHandle(ref, () => inputRef.current, []);

  const handleVisibilityToggle = () => {
    setType(type === 'password' ? 'text' : 'password');
    inputRef.current?.focus();
  };

  const { formatMessage } = useIntl();

  return (
    <div>
      <StyledDiv smallPlaceholder={props.smallPlaceholder}>
        <FormTextField
          {...props}
          type={type}
          autoComplete={type === 'password' ? props.autoComplete || 'off' : 'off'}
          spellCheck={false}
          ref={inputRef}
          elemAfterInput={
            <StyledIconContainer>
              <IconButton
                appearance="subtle"
                icon={type === 'text' ? WatchFilledIcon : WatchIcon}
                label={
                  type === 'text'
                    ? formatMessage({
                        id: 'password.field.password.hide',
                        defaultMessage: 'Hide password',
                      })
                    : formatMessage({
                        id: 'password.field.password.show',
                        defaultMessage: 'Show password',
                      })
                }
                onClick={handleVisibilityToggle}
              />
            </StyledIconContainer>
          }
        />
      </StyledDiv>
    </div>
  );
};

export default React.forwardRef(PasswordField);
